module.exports = __webpack_public_path__ + "img/temp1.5621455b.png";